import { Col, Row } from "antd";
import { StepDescription, StepLabel } from "./index.styled";

interface ProcessStepLabelProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  color?: string;
}

export const ProcessStepLabel: React.FC<ProcessStepLabelProps> = ({
  title,
  description,
  color,
}) => {
  return (
    <Row>
      <Col span={24}>
        <StepLabel color={color}>{title || "-"}</StepLabel>
      </Col>
      {description && (
        <Col span={24}>
          <StepDescription>{description}</StepDescription>
        </Col>
      )}
    </Row>
  );
};
